<template>
  <el-dialog v-model="status" :title="title" width="900px" top="3vh" @close="closeEdit">
    <div class="morderw">
      <div class="goodsw">
        <div class="osearch">
          <el-input size="small" v-model="search.goods_name" @keypress.enter="do_search" placeholder="输入产品名称搜索" style="width: 350px;" />
          <el-button size="small" type="primary" @click="do_search" @keypress.enter="do_search" icon="Search" style="margin-left: 10px;">搜索</el-button>
        </div>
        <div class="goodslsw">
          <div class="glist" v-for="(item,key) in goods.data" :key="key">
            <img class="litpic" :src="item.litpic" />
            <div class="ginfo">
              <div class="gname">{{item.goods_name}}</div>
              <div class="gspecs">
                <div class="specslis" v-for="(p,k) in item.specs" :key="k" @click="changeBuyNum(key,p.specs)">{{p.specs}}{{item.unit}}<span v-if="item.unit!='元'">/{{p.price}}元</span></div>
              </div>
              <div class="acto">
                <el-input-number v-model="item.buy_num" size="small" :step="0.1" :min="0.1" :max="999999" :precision="1" :controls="false" style="width: 80px;" @keypress.enter="addCart(key)" />
                <span class="cunit">{{item.unit}}</span>
                <el-button type="primary" size="small" icon="ShoppingCart" color="#94cf39" style="color: #ffffff; margin-left: 15px;" @click="addCart(key)">下单</el-button>
              </div>
            </div>
          </div>
          <el-button v-if="goods.current_page<goods.last_page" icon="DArrowRight" style="display: block; margin: 10px auto 0 auto;" @click="nextPage">{{loading?'加载中...':'加载下一页产品'}}</el-button>
        </div>
      </div>

      <div class="cartw">
        <div class="cgoodsw">
          <div class="empty" v-if="Object.keys(cartgoods).length==0">还未选择要下单的产品</div>
          <div class="cgoodsls" v-for="(item,key) in cartgoods" :key="key">
            <img class="litpic" :src="item.litpic" />
            <div class="ginfo">
              <div class="gname">{{item.goods_name}}</div>
              <div class="gspecs">{{item.specs}}{{item.unit}}</div>
              <div class="buyprice">
                <div class="price">￥{{item.price}}</div>
                <div class="buynum">
                  <el-icon size="14" style="padding: 5px; margin-right: 5px; color: #333333; vertical-align: top; background: #f5f5f5; cursor: pointer;" @click="changeNun(key,'dec')"><Minus /></el-icon>
                  <el-input-number v-model="item.buy_num" size="small" :step="1" :min="1" :max="99999" :precision="0" :controls="false" style="width: 70px; color: #333333;" @change="calcPrice" />
                  <el-icon size="14" style="padding: 5px; margin-left: 5px; color: #333333; vertical-align: top; background: #f5f5f5; cursor: pointer;" @click="changeNun(key,'add')"><Plus /></el-icon>
                </div>
              </div>
            </div>
            <div class="delout"><el-button size="small" type="danger" icon="Delete" circle style="cursor: pointer;" @click="delCgoods(key)" /></div>
          </div>
        </div>

        <div class="order-type">
          <span style="display: inline-block; width: 56px; padding-right: 4px; font-size: 12px; line-height: 24px; text-align: right;">订单类型</span>
          <el-radio-group v-model="orderType" size="small">
            <el-radio label="1">配送</el-radio>
            <el-radio label="2">自提</el-radio>
            <el-radio label="3">退货</el-radio>
          </el-radio-group>
        </div>

        <div class="address">
          <span style="display: inline-block; width: 56px; padding-right: 4px; font-size: 12px; line-height: 24px; text-align: right;">收货地址</span>
          <el-select size="small" v-model="addrkey" @change="do_search" style="width: 310px;">
            <el-option v-for="(item,key) in address" :key="key" :label="item.address+' '+item.uname+'/'+item.uphone" :value="key"></el-option>
          </el-select>
        </div>

        <div class="remark">
          <span style="display: inline-block; width: 56px; padding-right: 4px; font-size: 12px; line-height: 24px; text-align: right;">备注</span>
          <el-input size="small" type="text" v-model="remark" :maxlength="150" style="width: 310px;" />
        </div>

        <div class="morderact">
          <el-date-picker v-model="odate" type="date" size="small" value-format="YYYY-MM-DD" :editable="false" :disabled-date="elable_date" :clearable="false" style="width: 100px;"></el-date-picker>
          <div class="mintot" v-if = "orderType == 3">合计：<span>-{{totprice}}元</span></div>
          <div class="mintot" v-if = "orderType != 3">合计：<span>{{totprice}}元</span></div>
          <el-button class="subobtn" type="primary" color="#ff5907" style="color: #ffffff;" @click="subOrder" :loading="subLoading">确定下单({{Object.keys(cartgoods).length}}件)</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'MakeOrder',
  data(){
    return {
      status:false,
      title:'',
      goods:{data:[],total:0,current_page:1,last_page:1},
      search:{uid:null,page:1,goods_name:''},
      odate:this.getTomorrow(),
      remark:'',
      cartgoods: {},
      totprice:0,
      address:[],
      addrkey:0,
      orderType:'1',
      user:{},
      elable_date:function (time){
        return time.getTime()> Date.now()+8.64e7;
      },
      loading:false,
      subLoading:false
    }
  },
  methods:{
    init(user){
      var _this=this;
      if (typeof (user)!='undefined'){
        this.odate=this.getTomorrow();
        this.user=user;
        this.search.uid=user.id;
        this.title='代客下单（'+user.uname+' '+user.link_man+'/'+user.link_phone+'）';
        this.getAddress(user.id);
      }
      this.status=true;
      this.loading=true;
      this.RequestApi('ogoods_list.html',this.search).then(function (res){
        _this.loading=false;
        if(res.status==1){
          if(res.data.current_page==1){
            _this.goods=res.data;
          }else{
            _this.goods.current_page=res.data.current_page;
            _this.goods.last_page=res.data.last_page;
            _this.goods.data=_this.goods.data.concat(res.data.data);
          }
        }
      })
    },
    subOrder(){
      if(Object.keys(this.cartgoods).length==0) return this.TipsError('请先选择要下单的产品');
      if(this.address.length==0) return this.TipsError('请先给客户添加收货地址');
      var _this=this;
      if(this.odate.toString()!=this.getTomorrow().toString()){
        _this.confirm('您修改了下单日期，确认按修改的日期下单吗？',function (){
          _this.subNet();
        })
      }else{
        _this.subNet();
      }
    },
    subNet(){
      var data=[],address=this.address[this.addrkey],_this=this;
      for (let k in _this.cartgoods){
        data.push({
          'gid':_this.cartgoods[k].gid,
          'spid':_this.cartgoods[k].spid,
          'buy_num':_this.cartgoods[k].buy_num
        });
      }
      _this.subLoading=true;
   /*    console.log(data);
      if(_this.orderType == '3'){
        _this.totprice = -_this.totprice;
      } */
      _this.RequestApi('make_order.html',{'goods':data,'odate':_this.odate,'remark':_this.remark,'address':address,'pricetot':_this.totprice,'uid':_this.user.id,'otype':_this.orderType}).then(function (res){
        _this.subLoading=false;
        if(res.status==1){
          _this.TipSuccess(res.msg);
          _this.closeEdit();
        }else{
          _this.TipsError(res.msg);
        }
      })
    },
    addCart(key){
      if(typeof (this.goods.data[key].buy_num)=='undefined' || this.goods.data[key].buy_num==0){
        return this.TipsError('请输入数量');
      }
      var goods=this.goods.data[key],
          snum=this.goods.data[key].buy_num,
          buy_num=this.goods.data[key].buy_num,
          specs=this.goods.data[key].specs,
          specs2=this.goods.data[key].specs2;
      for(let k=specs.length-1;k>=0;k--){
        if(snum>0){
          snum=snum % specs[k].specs;
        }
      }
      if(snum>0){
        for(let k=0;k<specs.length;k++){
          snum=this.goods.data[key].buy_num % specs[k].specs;
          if(snum==0) break;
        }
      }
      if(snum>0){
        return this.TipsError('购买数量不正确，请重新输入');
      }
      var cdata= {};
      for(let k=0;k<specs2.length;k++){
        if(buy_num>0 && buy_num>=specs2[k]['specs']){
          let ckey=goods.id+'-'+specs2[k].spid,sbuynum=0;
          if(Object.prototype.hasOwnProperty.call(this.cartgoods,ckey)){
            sbuynum=parseInt(buy_num/specs2[k]['specs'])+this.cartgoods[ckey].buy_num;
          }else{
            sbuynum=parseInt(buy_num/specs2[k]['specs']);
          }
          cdata[ckey]={
            'gid':goods.id,
            'goods_name':goods.goods_name,
            'litpic':goods.litpic,
            'spid':specs2[k].spid,
            'buy_num':sbuynum,
            'specs':specs2[k]['specs'],
            'price':specs2[k]['price'],
            'unit':goods.unit
          };
          buy_num=buy_num % specs2[k]['specs'];
        }
      }
      if(buy_num>0){
        cdata=[];
        for(let k=0;k<specs2.length;k++){
          if(this.goods.data[key].buy_num >= specs2[k]['specs']){
            buy_num=this.goods.data[key].buy_num % specs2[k]['specs'];
            if(buy_num==0){
              let ckey=goods.id+'-'+specs2[k].spid,sbuynum=0;
              if(Object.prototype.hasOwnProperty.call(this.cartgoods,ckey)){
                sbuynum=parseInt(this.goods.data[key].buy_num/specs2[k]['specs'])+this.cartgoods[ckey].buy_num;
              }else{
                sbuynum=parseInt(this.goods.data[key].buy_num/specs2[k]['specs']);
              }
              cdata[ckey]={
                'gid':goods.id,
                'goods_name':goods.goods_name,
                'litpic':goods.litpic,
                'spid':specs2[k].spid,
                'buy_num':sbuynum,
                'specs':specs2[k]['specs'],
                'price':specs2[k]['price'],
                'unit':goods.unit
              };
              break;
            }
          }
        }
      }
      if(buy_num>0) return this.TipsError('购买数量不正确22，请重新输入');
      Object.assign(this.cartgoods,cdata);
      this.calcPrice();
    },
    changeBuyNum(key,specs){
      this.goods.data[key].buy_num=specs;
    },
    changeNun(key,type){
      if(type=='add'){
        this.cartgoods[key].buy_num+=1;
      }else{
        if(this.cartgoods[key].buy_num>1) this.cartgoods[key].buy_num-=1;
        else this.cartgoods[key].buy_num=1;
      }
      this.calcPrice();
    },
    calcPrice(){
      var totprice=0;
      for (let k in this.cartgoods){
        let mintot=this.calculation(this.cartgoods[k].price,this.cartgoods[k].buy_num,'*',2);
        totprice=this.calculation(totprice,mintot,'+',2);
      }
      this.totprice=totprice;
    },
    delCgoods(key){
      delete this.cartgoods[key];
      this.calcPrice();
    },
    do_search:function (){
      this.search.page=1;
      this.init();
    },
    nextPage(){
      if(this.loading) return false;
      this.search.page=this.goods.current_page+1;
      if(this.search.page>this.goods.last_page) return false;
      this.init();
    },
    getAddress(uid){
      var _this=this;
      this.RequestApi('user_address.html',{'uid':uid}).then(function (res){
        if(res.status==1){
          _this.address=res.data;
        }
      })
    },
    closeEdit:function (){
      this.title='';
      this.goods={data:[],total:0,current_page:1,last_page:1};
      this.search={page:1,goods_name:''};
      this.cartgoods={};
      this.totprice=0;
      this.addrkey=0;
      this.address=[{uname:'',uphone:'',address:''}];
      this.odate=this.getTomorrow();
      this.loading=false;
      this.subLoading=false;
      this.status=false;
    }
  }
}
</script>

<style scoped lang="less">
.order-type {
  margin-bottom: 8px;
}

.morderw{
  overflow: hidden;
  clear: both;
  .goodsw{
    float: left;
    width: 53%;
    height: 700px;
    overflow: hidden;
    .goodslsw{
      height: 674px;
      overflow-y: auto;
      .glist{
        display: flex;
        padding: 8px 0;
        border-bottom: 1px solid #E5E5E5;
        .litpic{
          display: block;
          width: 80px;
          height: 80px;
          flex-shrink: 0;
          border-radius: 4px;
        }
        .ginfo{
          padding-left: 8px;
          flex-grow: 1;
          .gname{
            width: 100%;
            font-size: 14px;
            line-height: 1.2;
            color: #000000;
            padding-bottom: 7px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .gspecs{
          clear: both;
          overflow: hidden;
          .specslis{
            float: left;
            padding: 0 8px;
            margin-right: 10px;
            margin-bottom: 5px;
            font-size: 12px;
            line-height: 2;
            background-color: #f1f1f1;
            border-radius: 5px;
            user-select: none;
            cursor: pointer;
            &:hover{
              color: #FFFFFF;
              background-color: #ff5907;
            }
          }
        }
        .acto{
          .cunit{
            display: inline-block;
            padding-left: 3px;
          }
        }
      }
    }
  }
  .cartw{
    display: flex;
    flex-direction: column;
    float: right;
    width: 45%;
    height: 700px;
    padding-left: 2%;
    border-left: 1px solid #d1d1d1;
    box-sizing: border-box;
    .cgoodsw{
      flex: 1;
      overflow-y: auto;
      .empty{
        font-size: 18px;
        line-height: 400px;
        color: #D1D1D1;
        text-align: center;
      }
      .cgoodsls{
        display: flex;
        padding: 8px 0;
        border-bottom: 1px solid #E5E5E5;
        .litpic{
          display: block;
          width: 80px;
          height: 80px;
          flex-shrink: 0;
          border-radius: 4px;
          user-select: none;
        }
        .ginfo{
          padding-left: 8px;
          flex-grow: 1;
          .gname{
            width: 100%;
            font-size: 14px;
            line-height: 1.2;
            color: #000000;
            padding-bottom: 7px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            user-select: none;
          }
          .gspecs{
            font-size: 14px;
            line-height: 2;
            color: #999999;
          }
          .buyprice{
            clear: both;
            overflow: hidden;
            .price{
              float: left;
              width: 90px;
              font-size: 14px;
              line-height: 24px;
              color: #d6352d;
            }
            .buynum{
              float: left;
              padding-left: 10px;
            }
          }
        }
        .delout{
          display: flex;
          width: 32px;
          flex-shrink: 0;
          align-items: center;
        }
      }
    }
    .morderact{
      padding-top: 8px;
      box-shadow: 0 -3px 3px #f9f9f9;
      .mintot{
        display: inline-block;
        width: 130px;
        padding-left: 10px;
        font-size: 14px;
        font-weight: bold;
        line-height: 32px;
        text-align: left;
        vertical-align: top;
        span{
          color: #ff813d;
        }
      }
      .subobtn{
        padding: 8px;
      }
    }
  }
}
</style>